import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { getAuth } from 'firebase/auth'

const httpLink = new HttpLink({
  uri: `${import.meta.env.VITE_API_BASE_URL}/api/graphql`,
})

const authLink = setContext(async (_, prevContext) => {
  const headers = (prevContext as { headers?: Record<string, string> }).headers
  let token: string | null = null
  try {
    const auth = getAuth()
    const user = auth.currentUser
    if (user) {
      token = await user.getIdToken()
    }
  } catch {
    // Firebase not yet initialized — proceed unauthenticated
  }
  return {
    headers: {
      ...headers,
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
  }
})

export const apolloClient = new ApolloClient({
  link: from([authLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: { fetchPolicy: 'cache-and-network' },
  },
})

// uploadFile is the ONLY place in the SPA that uses raw fetch() for non-GraphQL requests.
// Used exclusively for: POST /api/clients/:id/knowledge (multipart file upload)
export async function uploadFile<T>(path: string, formData: FormData): Promise<T> {
  let token: string | null = null
  try {
    const auth = getAuth()
    const user = auth.currentUser
    if (user) token = await user.getIdToken()
  } catch {
    // proceed unauthenticated
  }
  const res = await fetch(`${import.meta.env.VITE_API_BASE_URL}${path}`, {
    method: 'POST',
    headers: token ? { authorization: `Bearer ${token}` } : {},
    body: formData,
  })
  if (!res.ok) throw new Error(`${res.status} ${await res.text()}`)
  return res.json() as Promise<T>
}
